<app-navigation-header title="Key Detection Report" i18n-title="@@keyDetectionReport-keyDetectionReportTitle">
	<app-data-set
		#dataSet
		[dataSource]="dataSource"
		defaultPresentationMode="table"
		[appBreadcrumbLabel]="breadcrumbLabel"
		[rowId]="rowId"
		firstColumnProperty="deviceSerialNumber"
	>
		<app-data-set-toolbar>
			<div class="flex-space-around">
				<div *appActionGroup style="width: 100%; display: flex; flex-direction: column">
					<app-data-set-action-button
						style="flex: 1"
						label="Refine Filters"
						i18n-label="@@keyDetectionReport-refineFilters"
						svgIcon="sl-filter"
						(click)="onRefineFiltersClicked()"
						data-automation-id="key-detection-report-refine-filters-button"
					></app-data-set-action-button>
				</div>
				<div *appActionGroup style="width: 100%; display: flex; flex-direction: column">
					<app-data-set-action-button
						style="flex: 1"
						label="Download"
						i18n-label="@@keyDetectionReport-downloadReport"
						svgIcon="sl-download"
						(click)="onDownloadClicked()"
						data-automation-id="key-detection-report-download-button"
					></app-data-set-action-button>
				</div>
			</div>
		</app-data-set-toolbar>

		<app-data-set-content>
			<app-data-set-table-view>
				@if (
					loadingService.isLoading(generateKeyDetectionReportLoadingKey) ||
					loadingService.isLoading(generateKeyDetectionReportCsvLoadingKey) ||
					!finishedLoadingInitData
				) {
					<app-data-set-loading-row />
				}
				<table
					mat-table
					[dataSource]="dataSource"
					matSortActive="visitStartDate"
					matSortDirection="desc"
					matSort
					[hidden]="
						loadingService.isLoading(generateKeyDetectionReportLoadingKey) ||
						loadingService.isLoading(generateKeyDetectionReportCsvLoadingKey) ||
						!finishedLoadingInitData
					"
				>
					<tr class="mat-row" *matNoDataRow>
						<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
							No records found.
						</td>
					</tr>

					<ng-container matColumnDef="deviceSerialNumber">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@keyDetectionReport-serialNumber">
							Serial Number
						</th>
						<td mat-cell *matCellDef="let row">{{ row.deviceSerialNumber }}</td>
					</ng-container>

					<ng-container matColumnDef="deviceOwnerCompanyName">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@keyDetectionReport-deviceOwner">
							Device Owner
						</th>
						<td mat-cell *matCellDef="let row">{{ row.deviceOwnerCompanyName }}</td>
					</ng-container>

					<ng-container matColumnDef="keyDetectionStatus">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@keyDetectionReport-keyDetectionStatus">
							Key Detection Status
						</th>
						<td mat-cell *matCellDef="let row">{{ row.keyDetectionStatus }}</td>
					</ng-container>

					<ng-container matColumnDef="accessedByUserName">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@keyDetectionReport-accessedByUser">
							Accessed by User
						</th>
						<td mat-cell *matCellDef="let row">{{ row.accessedByUserFirstName }} {{ row.accessedByUserLastName }}</td>
					</ng-container>

					<ng-container matColumnDef="deviceLocation">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@keyDetectionReport-deviceLocation">
							Device Location
						</th>
						<td mat-cell *matCellDef="let row">{{ row.deviceLocation }}</td>
					</ng-container>

					@if (isCareCompany) {
						<ng-container matColumnDef="clientName">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@inventoryReport-client">Client</th>
							<td mat-cell *matCellDef="let row">{{ row?.clientFirstName ?? '' }} {{ row?.clientLastName ?? '' }}</td>
						</ng-container>

						<ng-container matColumnDef="clientIdn">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@inventoryReport-clientIdn">Client IDN</th>
							<td mat-cell *matCellDef="let row">{{ row?.clientIdn ?? '' }}</td>
						</ng-container>
					}

					<ng-container matColumnDef="propertyName">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@keyDetectionReport-propertyName">
							Property Name
						</th>
						<td mat-cell *matCellDef="let row">{{ row.propertyName }}</td>
					</ng-container>

					<ng-container matColumnDef="visitEndDate">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@keyDetectionReport-endDate">
							Visit End Date
						</th>
						<td mat-cell *matCellDef="let row">
							<div
								[innerHTML]="
									row.visitEndDate
										? (row.visitEndDate
												| date: 'mediumDate' : timeZoneService.utcOffset(row.visitEndDate, row.locationTimezoneName)) +
											'<br/>' +
											(row.visitEndDate
												| date: 'shortTime' : timeZoneService.utcOffset(row.visitEndDate, row.locationTimezoneName)) +
											' ' +
											(row.locationTimezoneName | abbreviatedTimezone: row.visitEndDate)
										: '- - -'
								"
							></div>
						</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
					<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
				</table>
			</app-data-set-table-view>
		</app-data-set-content>
	</app-data-set>
</app-navigation-header>
